import { render } from "./email-campaign-add.vue?vue&type=template&id=143d5c0a"
import script from "./email-campaign-add.vue?vue&type=script&lang=js"
export * from "./email-campaign-add.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__